import IndexedDB from "@/helpers/IndexedDB.js";
export default class Report {
	constructor({id, init_date, end_date, ids, report_type, url_file, type_file, language}) {
		this.id = id || 0;
		this.report_type = report_type || "";
		this.url_file = url_file || "";
		this.init_date = init_date || "";
		this.end_date = end_date || "";
		this.type_file = type_file || "csv";
		this.resources_id = ids || [];
		this.language = language || "ES";
	}

	async saveToIndexedDB() {
		let report = this;
		try {
			await IndexedDB.save("upload_files", report, report.id);
			console.info("save data file");
		} catch (error) {
			console.error(error);
		}
	}
	getUploadedFiles() {
		return IndexedDB.getAll("upload_files");
	}
}
